import ConnectedTvNetworks from 'pages/MasterCampaignPlanPage/new/components/Projections/ConnectedTvNetworks'
import TopInternetDisplaySites from 'pages/MasterCampaignPlanPage/new/components/Projections/TopInternetDisplaySites'
import { FC } from 'react'

import { EuiPanel, EuiTitle, EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlan, MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'

export interface PlacementChartsProps {
  masterCampaignPlan: MasterCampaignPlan
  hasInternet: boolean
  hasTv: boolean
  whereAdsAppearTitle?: string
  auctionBasedPlacementsSection?: MasterCampaignPlanCustomSection
  ctvSection?: MasterCampaignPlanCustomSection
  internetSection?: MasterCampaignPlanCustomSection
}

const PlacementCharts: FC<PlacementChartsProps> = ({ masterCampaignPlan, hasInternet, hasTv, whereAdsAppearTitle, auctionBasedPlacementsSection, ctvSection, internetSection }) => {
  if (auctionBasedPlacementsSection?.hideAll === true) {
    return null
  }

  const title = whereAdsAppearTitle || 'Where Ads Appear'
  const auctionTitle = auctionBasedPlacementsSection?.title ?? 'Auction-Based Placements'
  const auctionContent = auctionBasedPlacementsSection?.content ?? 'Ad placements are made via auction-based ad exchanges. Bidding is optimized to prioritize audience and geographic accuracy over publisher allocation, so some variation in final distribution may occur.'
  const auctionShowTitle = auctionBasedPlacementsSection?.showTitle ?? true

  const width = hasInternet && hasTv ? '45%' : '90%'

  return (
    <>
      <EuiPanel paddingSize='l'>
        <EuiTitle size='m'>
          <h2>{title}</h2>
        </EuiTitle>

        <EuiSpacer size='l' />

        <div style={{ marginLeft: '2rem' }}>
          {auctionShowTitle && (
            <EuiTitle size='xs'>
              <h3>{auctionTitle}</h3>
            </EuiTitle>
          )}

          <EuiSpacer size='s' />

          <EuiText size='m' style={{ whiteSpace: 'pre-wrap' }}>
            {auctionContent}
          </EuiText>
        </div>

        <EuiSpacer size='l' />

        <EuiFlexGroup gutterSize='xl'>
          {hasTv && (
            <EuiFlexItem style={{ width: width }}>
              <ConnectedTvNetworks masterCampaignPlan={masterCampaignPlan} section={ctvSection} />
            </EuiFlexItem>
          )}

          {hasInternet && (
            <EuiFlexItem style={{ width: width }}>
              <TopInternetDisplaySites masterCampaignPlan={masterCampaignPlan} section={internetSection} />
            </EuiFlexItem>
          )}
        </EuiFlexGroup>
      </EuiPanel>
    </>
  )
}

export default PlacementCharts
